import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { DataService } from './data.service';
import { ToastrService } from './toastr.service';

@Injectable()
export class UnifiedRedemptionService {
    unifiedRedemption: any;
    model: any = {};

    constructor(private _dataService: DataService,
        private _authenticationService: AuthenticationService,
        private _toastrService: ToastrService,
        private _router: Router) { }


    async identifyInputKey(input): Promise<any> {
        return new Promise((rs, rj) => {
            this._dataService.post('/landingpage/checkInputKey', { input: input }).subscribe((res: any) => {
                if (!!res.error || res.response == 'failed') {
                    console.error(res.error || res.msg);
                    // this._toastrService.typeCustomError(res.error || res.msg);
                    return rs({ error: (res.error || res.msg), data: null });
                }

                // console.log(`Input Key is a ${res.data.keyType}`);
                rs({ error: null, data: res.data });
            }, (err) => {
                console.error(err);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./public/app/_services/unifiedRedemption.service.ts